<template>
    <button class="c-button" :class="[{'border': hollow, 'z-dis': disabled}, `s-${color}`]"
		:style="{
			'min-width': compWidth,
			'height': compHeight,
			'border-color': background,
			'border-radius': compRadius,
			'font-size': compFontSize,
			'color': fontColor,
			'background': background
		}"
		:disabled="!!disabled" @click="$event => $emit('click', $event)"
	>
		<div class="flex-center">
			<i v-if="iconClass" class="tf" :class="[iconClass]"></i>
			<span><slot></slot></span>
		</div>
	</button>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		props: {
			power: String,
			
			width: [Number, String],  // 自定义宽度
			
			height: [Number, String],  // 自定义高度
			
			color: {  // 按钮颜色（default: 系统辅色；）
				type: String,
				default: 'default'
			},
			
			hollow: Boolean,  // 是否为空心按钮
			
			radius: String,  //  圆角大小
			
			size: {  // 按钮尺寸（s：小号；m：中号；l：大号）
				type: String,
				default: 's'
			},
			
			fontSize: String,  // 字体大小
			
			fontColor: String,  // 字体颜色
			
			background: String,  //  按钮颜色
			
			icon: String,  // 按钮图标（add：添加）
			
			disabled: Boolean  // 禁用
		},
		
		computed: {
			...mapState(['elder']),
			
			compWidth() {
				if (this.width) {
					return this.width + 'px';
				}
				
				return {
					s: '2.18rem',
					m: '300px'
				}[this.size];
			},
			
			compHeight() {
				if (this.height) {
					return this.height + 'px';
				}
				
				return {
					s: this.elder ? '46px' : '.72rem',
					m: this.elder ? '60px' : '.96rem'
				}[this.size];
			},
			
			compRadius() {
				return {
					s: this.elder ? '23px' : '.36rem',
					m: this.elder ? '30px' : '.48rem'
				}[this.size];
			},
			
			compFontSize() {
				if (this.fontSize) {
					return this.fontSize + 'px';
				}
				
				return {
					s: this.elder ? '20px' : '.3rem',
					m: this.elder ? '24px' : '.34rem'
				}[this.size];
			},
			
			iconClass() {
				return {
					'add': 'tf-plus',
					'upload': 'tf-upload',
					'signet': 'tf-signet'
				}[this.icon];
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-button {
		box-sizing: border-box;
		position: relative;
		border: 1px solid #0366F1;
		padding: 0 1em;
		white-space: nowrap;
		color: #fff;
		background: #0366F1;
		
		&.border {
			color: #000;
			background: #fff !important;
		}
		
		&:not(.border) {
			color: #fff !important;
		}
		
		&.z-dis {
			border: none !important;
			color: #999 !important;
			background: #eee !important;
			cursor: not-allowed !important;
		}
		
		.tf {
			margin-right: .5em;
			font-size: 1em;
			
			&.tf-upload,
			&.tf-signet {
				color: #1492FF;
			}
		}
		
		span {
			display: inline-block;
			vertical-align: 1px;
		}
	}
	
	colorList = ({
		name: 'gray',
		normal: #ddd,
		font: #686B73
	} {
		name: 'yellow',
		normal: #F1960D
	} {
		name: 'green',
		normal: #00B578
	} {
		name: 'red',
		normal: #E63633
	});
	
	.c-button
		for item in colorList
			&.s-{item.name}
				color: item.normal;
				color: item.font;
				border-color: item.normal;
				background: item.normal;
</style>
